(function () {
  'use strict';

  angular.module('ringbaPortal').component('joinInviteV2', {
    bindings: {
      inviteStatus: '<'
    },
    controller: JoinInviteV2Controller,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/auth/v2/join-invitev2.view.html'
  });

  function JoinInviteV2Controller(
    $filter,
    $state,
    $stateParams,
    bsLoadingOverlayService,
    whitelabelService,
    cacheService,
    invitesService
  ) {
    'ngInject';

    const vm = this;

    vm.isWhitelabeledSite = false;

    vm.$onInit = onInit;

    function onInit() {
      _getFlowFromQueryParams();
      _getUserDetailsFromQueryParams();

      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';

      if (vm.inviteStatus.isInvitationValid) {
        _checkIfUserExists(vm.inviteStatus);
      } else {
        _setErrorMessage();
      }
      _checkPreviewMode();
    }

    function _getFlowFromQueryParams(){
      vm.flow = $stateParams.flow || 'invite';

      vm.isPRP = vm.flow == 'prp';
      vm.isBRP = vm.flow == 'brp';
      vm.isORP = vm.isPRP || vm.isBRP;
      vm.isInvite = vm.flow == 'invite';
    }

    function _getUserDetailsFromQueryParams() {
      vm.inviteData = vm.inviteData || {};
      vm.inviteData.firstName = $stateParams.fname || '';
      vm.inviteData.lastName = $stateParams.lname || '';
      vm.inviteData.publisherName = $stateParams.pubname || '';
      vm.inviteData.buyerName = $stateParams.buyername || '';
      vm.inviteData.accountName = $stateParams.account || '';
    }

    function _checkIfUserExists(status) {
      if (status.userExists) {
        bsLoadingOverlayService.start();
        _acceptInvite($stateParams.inviteId, {});
      }
    }

    function _acceptInvite(inviteId, user) {
      return invitesService.joinInvite(inviteId, user).then(function () {
        bsLoadingOverlayService.stop();
        vm.inviteAccepted = true;
      }).catch(function (err) {
        bsLoadingOverlayService.stop();
        vm.errorMessage = (err.data && err.data.message) || $filter('translate')('JOIN_INVITE_GENERIC_ERROR_MESSAGE');
      });
    }

    function _setErrorMessage() {
      if (vm.inviteStatus.inviteNotFound) {
        vm.inviteStatus.errorMessage = $filter('translate')('JOIN_INVITE_NOT_FOUND_SUBHEADER');
      } else if (vm.inviteStatus.isTechnicalError) {
        vm.inviteStatus.errorMessage = $filter('translate')('JOIN_INVITE_TECHNICAL_ERROR_SUBHEADER');
      } else {
        vm.inviteStatus.errorMessage = $filter('translate')('JOIN_INVITE_EXPIRED_SUBHEADER');
      }
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('join-invite-preview');
        vm.isLightTheme = vm.currentTheme.isLightTheme;
        cacheService.remove('join-invite-preview');
      }
    }

  }
})();
